// The trial "Get started" checklist. The sidebar in apps/app and the trial
// quick-start email both read this list, and each keys its copy and its done
// check by id, so adding or removing an item fails typecheck in both until they
// follow.
export const TRIAL_CHECKLIST = [
	{ id: "email", label: "Add shared email", path: "/settings/emails" },
	{ id: "widget", label: "Install widget", path: "/settings/widget" },
	{
		id: "github",
		label: "Connect GitHub",
		path: "/settings/integrations/github",
	},
	{
		id: "linear",
		label: "Connect Linear",
		path: "/settings/integrations/linear",
	},
	{ id: "mcp", label: "Use MCP", path: "/settings/mcp" },
] as const

export type TrialChecklistId = (typeof TRIAL_CHECKLIST)[number]["id"]

export type TrialChecklistProgress = Record<TrialChecklistId, boolean>

export type TrialChecklistStep = (typeof TRIAL_CHECKLIST)[number] & {
	isDone: boolean
}

export function trialChecklistSteps(
	progress: TrialChecklistProgress,
): TrialChecklistStep[] {
	return TRIAL_CHECKLIST.map((item) => ({
		...item,
		isDone: progress[item.id],
	}))
}
